import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import { store } from './store/store';

const container = document.querySelector('#root');
const root = createRoot(container!); // non-null assertion operator is required if we use TypeScript -> https://reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html

root.render(
    <Provider store={store}>
        <App />
    </Provider>
);
